<template>
  <v-footer dark :color="themeColor" min-height="200" tag="footer">
    <v-row>
      <v-col cols="12" md="4">
        <h3 class="headline mb-3">{{organization.name}}</h3>
        <ul class="body-1 pl-0">
          <li v-if="organization.address">
            <v-icon small left>mdi-map-marker</v-icon>
            {{organization.address.value}}
          </li>
          <li v-if="organization.phone">
            <v-icon small left>mdi-phone</v-icon>
            {{organization.phone}}
          </li>
          <li v-if="organization.email">
            <v-icon small left>mdi-at</v-icon>
            <a :href="'mailto:' + organization.email" class="nav ml-1">{{organization.email}}</a>
          </li>
          <li v-if="organization.website">
            <v-icon small left>mdi-web</v-icon>
            <a :href="webLink" target="_blank" class="nav ml-1">{{organization.website}}</a>
          </li>
        </ul>
      </v-col>
      <v-col cols="12" md="8">
        <blockquote class="subtitle-1 text-pre-line">{{organization.description}}</blockquote>
      </v-col>
    </v-row>
  </v-footer>
</template>

<script>
  export default {
    name: 'Footer',
    props: {
      organization: {
        type: Object,
        required: true
      }
    },
    computed: {
      themeColor () {
        return this.$store.getters.setting('order.footer.color') || '#1a2c05'
      },
      webLink () {
        let url = this.organization.website
        if(url) {
          if(url.includes(':')) {
            return url
          }
          return 'http://' + url
        }
        return null
      }
    }
  }
</script>

<style scoped>
  .nav {
    text-decoration: none;
    color: inherit;
  }
  .nav:visited {
    color: inherit;
  }
</style>
<style>
  .v-footer ul {
    list-style-type: none;
  }
</style>
